import AppComponent from '../base/app-component.ts';

export class ListaPresentazioni extends AppComponent {
  static override componentName = 'wc-lista-presentazioni';

  protected override get templateId() { return 'lista-presentazioni'; }

  private presentazioni: Record<string, unknown>[] = [];
  private loading = true;
  private error = '';

  protected override buildRenderingData(): Record<string, unknown> {
    return {
      ...super.buildRenderingData(),
      loading: this.loading,
      error: this.error,
      presentazioni: this.presentazioni,
    };
  }

  protected override afterRender(): void {
    if (this.loading) {
      this.loadData();
      return;
    }
    this.setupActions();
  }

  private async loadData(): Promise<void> {
    const result = await this.api.presentazioni.lista();
    this.loading = false;
    if (!result.ok) {
      this.error = result.error;
    } else {
      this.presentazioni = result.data.presentazioni as unknown as Record<string, unknown>[];
    }
    this.render();
  }

  private setupActions(): void {
    this.delegate.on('click', '[data-action="scarica-csv"]', (e: Event) => {
      e.preventDefault();
      const el = (e.target as HTMLElement).closest('[data-id]') as HTMLElement | null;
      const id = Number(el?.dataset.id);
      if (id) window.open(`/api/presentazioni/${id}/export-csv`, '_blank');
    });
  }
}
